export interface Month {
  name: string;
  days: number;
}

export const months: Month[] = [
  { name: 'January', days: 31 },
  { name: 'February', get days() { return (new Date().getFullYear() % 4 === 0) ? 29 : 28; } },
  { name: 'March', days: 31 },
  { name: 'April', days: 30 },
  { name: 'May', days: 31 },
  { name: 'June', days: 30 },
  { name: 'July', days: 31 },
  { name: 'August', days: 31 },
  { name: 'September', days: 30 },
  { name: 'October', days: 31 },
  { name: 'November', days: 30 },
  { name: 'December', days: 31 }
];
  
export const daysIterable = Array(31).fill(0).map((value, i) => i + 1);



// WEBPACK FOOTER //
// ./src/gs-core/common/models/month.ts